import { ArrowLeftIcon } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { PageHeader } from "@/components/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useAbstract } from "@/features/abstract/api/get-abstract";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { QaList } from "@/features/qa/components/qa-list";
import { pageTitle } from "@/utils/page-title";
import { useTranslation } from "react-i18next";

export function AbstractPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { congress } = useCongress();

  const {
    data: abstract,
    isLoading,
    isSuccess: isAbstractSuccess,
  } = useAbstract(id ?? "");

  if (isLoading) {
    return (
      <div>
        <title>{pageTitle(t("meta.abstract"))}</title>
        <Button variant="link" disabled asChild>
          <Link to="/abstracts">
            <ArrowLeftIcon className="mr-2 size-4" />
            {t("common.back")}
          </Link>
        </Button>
        <Skeleton className="h-9 w-96" />
      </div>
    );
  }

  if (!isAbstractSuccess) {
    return (
      <div>
        <title>{pageTitle(t("meta.abstract"))}</title>
        <Button variant="link" asChild>
          <Link to="/abstracts">
            <ArrowLeftIcon className="mr-2 size-4" />
            {t("common.back")}
          </Link>
        </Button>
        <PageHeader title={t("meta.abstract")} />
        <div>{t("common.error")}</div>
      </div>
    );
  }

  return (
    <div>
      <title>{pageTitle(`${abstract.title}`)}</title>
      <Button variant="link" asChild>
        <Link to="/abstracts">
          <ArrowLeftIcon className="mr-2 size-4" />
          {t("common.back")}
        </Link>
      </Button>
      <PageHeader title={`${abstract.title}`} />

      <QaList
        congressId={congress.id}
        contentId={abstract.id}
        eventType="ABSTRACT"
      />
    </div>
  );
}
